import { z } from 'zod';
/**
 * A reusable party of players — "il gruppo di Marco". Groups are the spine of session
 * management: people belong to a group, and one-shots/instances are started and scheduled
 * for a group. A person can belong to several groups; a group can run many adventures.
 *
 * `color` is an identity hue (mapped to the candlelit palette in the web app) so a GM can
 * tell their tables apart at a glance. `memberIds` reference {@link Person} ids.
 */
/** Identity hues for a group, mapped to palette tokens in the web app. */
export const groupColorSchema = z.enum(['gold', 'ember', 'sage', 'azure', 'plum', 'copper']);
export const groupSchema = z.object({
    schemaVersion: z.literal(1).default(1),
    id: z.string(),
    name: z.string(),
    color: groupColorSchema.default('gold'),
    notes: z.string().default(''),
    /** Person ids that make up the recurring party. */
    memberIds: z.array(z.string()).default([]),
    createdAt: z.string(),
    updatedAt: z.string(),
});
/** Payload to create/update a group from the Groups page. */
export const groupInputSchema = z.object({
    name: z.string().min(1),
    color: groupColorSchema.optional(),
    notes: z.string().optional(),
    memberIds: z.array(z.string()).optional(),
});
//# sourceMappingURL=groups.js.map